import React from 'react';

const Leads = () => {
  return (
    <div>
      <h1>Leads</h1>
    </div>
  );
};

export default Leads;